import { useContext } from 'react';
import { RootStoreContext, IRootStore } from '@stores/RootStore';

export const useStore = (): IRootStore => {
  const store = useContext(RootStoreContext);
  if (store === null) {
    throw new Error('Store cannot be null, please add a context provider');
  }
  return store;
};
